// removed by extract-text-webpack-plugin
module.exports = {"records_top_ten":"records_top_ten__3QvZL","parameters_wrapper":"parameters_wrapper__3t0mR","parameters_list":"parameters_list__2XFKz","active":"active__1e8jQ","table_wrapper":"table_wrapper__1h4gM","table_title":"table_title__3-qVf","table_description":"table_description__2Q0tN","table":"table__3q3rV"};


//////////////////
// WEBPACK FOOTER
// ./components/records-top-ten/style.scss
// module id = g7QX
// module chunks = 6